import React from 'react'
import styled from 'styled-components'
import Colors from '../commons/Colors'

import * as DateUtils from '../commons/DateUtils'

import RoundTagComponent from '../commons/components/RoundTagComponent'

export const getTagColor = source => {
    if (source) {
        if (source === 'Portal') {
            return Colors.lightRed
        }
        return Colors.lightishBlue
    }

    return Colors.grass
}

const NotificationCardComponent = ({
    notification,
    handleClick,
    isNotificationNew,
    isNotificationUnRead,
}) => {
    return (
        <CardContainer>
            <CardHeader>
                <TitleContainer>
                    <TitleText isNotificationUnRead={isNotificationUnRead}>
                        {notification?.name}
                    </TitleText>
                </TitleContainer>
                <TagsContainer>
                    {isNotificationNew && (
                        <NewTagNotificationTag>
                            <RoundTagComponent
                                text={'Novo'}
                                color={Colors.heavyGreen}
                            />
                        </NewTagNotificationTag>
                    )}

                    <RoundTagComponent
                        text={notification?.source.name}
                        color={getTagColor(notification?.source.name)}
                    />
                </TagsContainer>
            </CardHeader>
            <CardBody>
                <DescriptionContainer>
                    <DescriptionText>
                        {notification?.description}
                    </DescriptionText>
                </DescriptionContainer>
                <FileURLContainer>
                    <FileURLText
                        data-testid="url-notification-card"
                        href={null}
                        target="_blank"
                        onClick={() => handleClick()}
                    >
                        Visualizar notícia
                    </FileURLText>
                </FileURLContainer>
            </CardBody>
            <CardFooter>
                <FooterContainer>
                    <FooterText>
                        {DateUtils.dateFormat(notification?.updatedAt)}
                    </FooterText>
                </FooterContainer>
                {notification?.version && (
                    <FooterContainer>
                        <ReleaseInformationText>
                            {`Disponível na versão ${notification?.version}`}
                        </ReleaseInformationText>
                    </FooterContainer>
                )}
            </CardFooter>
            <Divider />
        </CardContainer>
    )
}

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
`
const CardHeader = styled.div`
    display: flex;
    padding: 10px 0 0 20px;
`
const TitleContainer = styled.div`
    padding: 0 10px 0 10px;
    max-width: 60%;
`
const TitleText = styled.span`
    font-family: Roboto;
    font-size: 12px;
    font-weight: ${props => (props.isNotificationUnRead ? 'bold' : 'normal')};
    color: ${props =>
        props.isNotificationUnRead ? Colors.brownishGrey : Colors.brownishGrey};
`
const TagsContainer = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 2px;
`
const NewTagNotificationTag = styled.div`
    padding-right: 6px;
`

const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 8px 8px 0 30px;
`
const DescriptionContainer = styled.div`
    padding-bottom: 5px;
    padding-right: 10px;
    max-width: 100%;
`

const DescriptionText = styled.span`
    font-family: Roboto;
    font-size: 12px;
    font-weight: light;
    color: ${Colors.brownishGrey};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`
const FileURLContainer = styled.div``

const FileURLText = styled.a`
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    color: ${Colors.orange};
    text-decoration: none;

    cursor: pointer;
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.8;
        color: ${Colors.orange};
        text-decoration: underline;
    }
`
const CardFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    align-content: flex-end;
    justify-content: flex-end;
    padding-bottom: 8px;
`
const FooterContainer = styled.div`
    padding-right: 20px;
`
const FooterText = styled.span`
    font-family: Roboto;
    font-size: 9px;
    color: ${Colors.brownishGrey};
`
const ReleaseInformationText = styled.span`
    font-family: Roboto;
    font-size: 9px;
    color: ${Colors.lightBlueGreyTwo};
`
const Divider = styled.div`
    height: 1px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    background-color: rgba(199, 199, 204, 0.5);
`

export default NotificationCardComponent
